import { render, staticRenderFns } from "./EventMessages.vue?vue&type=template&id=2212f25f&scoped=true"
import script from "./EventMessages.vue?vue&type=script&lang=js"
export * from "./EventMessages.vue?vue&type=script&lang=js"
import style0 from "./EventMessages.vue?vue&type=style&index=0&id=2212f25f&prod&lang=scss"
import style1 from "./EventMessages.vue?vue&type=style&index=1&id=2212f25f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2212f25f",
  null
  
)

export default component.exports